import DocumentFile from '../Icons/DocumentFile';
import AudioFile from '../Icons/AudioFile';
import VideoFile from '../Icons/VideoFile';
import ImageFile from '../Icons/ImageFile';

export { bytesToMB, filesize } from '../../../utils/unit-converter';
export const percentage = ({ total, loaded }) =>
  Math.round((loaded / total) * 100);

const fileTypeIcons = {
  DOCUMENT: DocumentFile,
  AUDIO: AudioFile,
  VIDEO: VideoFile,
  IMAGE: ImageFile,
};

export const getFileTypeIcon = type => fileTypeIcons[type];
